(()=>{
if (window.__BATTEN_INIT) return;
window.__BATTEN_INIT = true;
const BATTEN = window.BATTEN_HOME || {email:'',bands:[],teams:[]};
const $id = id => document.getElementById(id);
const has = id => !!$id(id);

/* ═══ CONFIG ═══ */
const BANDS = [...document.querySelectorAll('[data-pick="qty"] .tile')]
  .map(t => ({ min: parseInt(t.dataset.val), price: parseInt((t.querySelector('small')||{}).textContent?.replace(/\D/g,'') || 0) }))
  .filter(b => b.min && b.price)
  .sort((a,c) => a.min - c.min);
const TEAMS = [...document.querySelectorAll('[data-team]')].map(el => ({
  el, shell: el.dataset.shell, accent: el.dataset.accent, lining: el.dataset.lining }));

{const _y=document.getElementById("yr"); if(_y)_y.textContent=new Date().getFullYear();}

/* ═══ Mini parka cards ═══ */
function miniParka(t){
  return `<svg viewBox="0 0 120 170" role="img" aria-label="${t.name} custom parka in ${t.sport}">
    <path d="M44 36 C44 12 51 4 60 4 C69 4 76 12 76 36 Z" fill="${t.lining}"/>
    <path d="M44 36 C44 12 51 4 60 4 C69 4 76 12 76 36 L71 36 C71 18 66 11 60 11 C54 11 49 18 49 36 Z" fill="${t.shell}"/>
    <path d="M42 36 L27 41 L21 104 L35 107 L39 57 Z" fill="${t.shell}" stroke="rgba(0,0,0,.3)" stroke-width="1.4"/>
    <path d="M78 36 L93 41 L99 104 L85 107 L81 57 Z" fill="${t.shell}" stroke="rgba(0,0,0,.3)" stroke-width="1.4"/>
    <path d="M42 36 C42 36 48 32 60 32 C72 32 78 36 78 36 L82 160 L38 160 Z" fill="${t.shell}" stroke="rgba(0,0,0,.3)" stroke-width="1.4"/>
    <rect x="38" y="96" width="44" height="7" fill="${t.accent}"/>
    <rect x="21" y="96" width="16" height="8" fill="${t.accent}"/>
    <rect x="83" y="96" width="16" height="8" fill="${t.accent}"/>
    <path d="M49 34 L71 34 L69 41 L60 45 L51 41 Z" fill="${t.lining}"/>
    <line x1="60" y1="40" x2="60" y2="160" stroke="rgba(0,0,0,.4)" stroke-width="2.4" stroke-dasharray="1.5 2.5"/>
  </svg>`;
}
TEAMS.forEach(t => { if (!t.el.querySelector('img')) t.el.insertAdjacentHTML('afterbegin', miniParka(t)); });

/* ═══ Swatches ═══ */
const _dz = document.querySelector('.batten-designer');
const picked = { shell:"#123A5E", accent:"#C8102E",
                 lining: (_dz && _dz.dataset.lining) || "#EFEFEF" };
const NAMES  = { shell:"Navy", accent:"Red",
                 lining: (_dz && _dz.dataset.liningName) || "Natural" };
document.querySelectorAll(".swatches").forEach(group=>{
  const target = group.dataset.target;
  const sws = group.querySelectorAll(".sw");
  if (sws.length && ![...sws].some(x => x.getAttribute("aria-pressed") === "true")) {
    sws[0].setAttribute("aria-pressed","true");   // default colour was deleted — use the first
  }
  sws.forEach(b=>{
    if (b.getAttribute("aria-pressed") === "true") {
      picked[target] = b.dataset.hex;
      NAMES[target]  = b.dataset.name;
    }
    b.addEventListener("click",()=>{
      picked[target] = b.dataset.hex;
      NAMES[target]  = b.dataset.name;
      group.querySelectorAll(".sw").forEach(s=>s.setAttribute("aria-pressed","false"));
      b.setAttribute("aria-pressed","true");
      paint();
    });
  });
});
function isLight(hex){
  const r=parseInt(hex.substr(1,2),16),g=parseInt(hex.substr(3,2),16),b=parseInt(hex.substr(5,2),16);
  return (r*299+g*587+b*114)/1000>150;
}
function paint(){
  if(!has("p-hood")) return;
  ["p-hood","p-slv1","p-slv2","p-upper","p-lower"].forEach(id=>document.getElementById(id).setAttribute("fill",picked.shell));
  ["p-stripe","p-cuff1","p-cuff2"].forEach(id=>document.getElementById(id).setAttribute("fill",picked.accent));
  ["p-hoodline"].forEach(id=>document.getElementById(id).setAttribute("fill",picked.lining));
  document.getElementById("p-name").setAttribute("fill", isLight(picked.shell)?"rgba(0,0,0,.78)":"rgba(255,255,255,.94)");
  const setv=(id,v)=>{const el=document.getElementById(id); if(el) el.value=v;};
  setv("f_shell",NAMES.shell); setv("f_accent",NAMES.accent); setv("f_lining",NAMES.lining);
}

/* ═══ Tiles ═══ */
const answers={sport:"",qty:12};
document.querySelectorAll("[data-pick]").forEach(group=>{
  const key=group.dataset.pick;
  group.querySelectorAll(".tile").forEach(t=>{
    t.addEventListener("click",()=>{
      group.querySelectorAll(".tile").forEach(x=>x.setAttribute("aria-pressed","false"));
      t.setAttribute("aria-pressed","true");
      answers[key]= key==="qty" ? parseInt(t.dataset.val) : t.dataset.val;
      if(key==="qty") price();
      document.getElementById("f_"+(key==="qty"?"qty":"sport")).value=answers[key];
      setTimeout(()=>go(step+1),220);
    });
  });
});
function money(n){return "$"+n.toLocaleString("en-US")}
function price(){
  if(!has("unitPrice")) return;
  const n=answers.qty||12;
  let band=BANDS[0]; for(const b of BANDS) if(n>=b.min) band=b;
  const up=document.getElementById("unitPrice");
  up.innerHTML=money(band.price)+' <small>each</small>';
  const ann=document.getElementById("priceAnnounce");
  if(ann) ann.textContent = "Price updated: "+money(band.price)+" per parka, "+money(band.price*n)+" estimated total.";
  const tp=document.getElementById("totalPrice"); if(tp) tp.textContent=money(band.price*n);
  const fu=document.getElementById("f_unit"); if(fu) fu.value=band.price;
}
if (has("team")) $id("team").addEventListener("input",e=>{
  const v=(e.target.value||"").trim().toUpperCase().slice(0,9);
  const _pn=document.getElementById("p-name"); if(_pn) _pn.textContent=v||"NAME";
});

/* ═══ Stepper ═══ */
let step=1; const TOTAL=4;
function go(n){
  if(!document.querySelector(".qstep")) return;
  if(n<1||n>TOTAL) return; step=n;
  document.querySelectorAll(".qstep").forEach(s=>s.classList.toggle("on",+s.dataset.step===step));
  for(let i=1;i<=TOTAL;i++) document.getElementById("pb"+i).classList.toggle("on",i<=step);
  const panel=document.querySelector(".qstep.on");
  if(panel){
    const h=panel.querySelector("h3");
    if(h){ h.setAttribute("tabindex","-1"); h.focus({preventScroll:true}); }
    else { const f=panel.querySelector("input,textarea"); if(f) f.focus({preventScroll:true}); }
  }
}
document.querySelectorAll("[data-next]").forEach(b=>b.addEventListener("click",()=>{
  if(step===1&&!answers.sport){flash(1);return}
  if(step===2&&!answers.qty){flash(2);return}
  if(step===3&&!document.getElementById("team").value.trim()){document.getElementById("team").reportValidity();return}
  go(step+1);
}));
document.querySelectorAll("[data-back]").forEach(b=>b.addEventListener("click",()=>go(step-1)));
function flash(n){
  document.querySelector('.qstep[data-step="'+n+'"] .tiles')
    .animate([{opacity:1},{opacity:.35},{opacity:1}],{duration:340});
}

/* ═══ Submit ═══ */
if (has("quoteForm")) $id("quoteForm").addEventListener("submit", e => {
  const form = e.target;
  if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); return; }
  const btn = $id("submitBtn");
  if (btn) { btn.disabled = true; btn.textContent = "Sending…"; }
  // no preventDefault — Shopify handles the post and re-renders with the success state
});
// Shopify returns to the page with ?contact_posted=true — scroll the confirmation into view
if (location.search.indexOf("contact_posted=true") > -1 && has("sentMsg")) {
  $id("sentMsg").scrollIntoView({ block: "center" });
}

if (has("parka")) paint();
if (has("unitPrice")) price();
if (document.querySelector(".qstep")) go(1);

})();